// extracted by mini-css-extract-plugin
export default {"root":"CB3xy4ao2Dtl3vpR95uW","header":"S4zeFO3MUs_K7efDErDG","row":"dIp5qKfJgAyOkJB6Iq0Q","footer":"oFeuHrQ40ww5cGVLsA_2","name":"VMGDQzILH4TMPVW88cn7","cell":"JUPyKWTuKO9CLQlk7F00"};